export const TERMS_AR = {
  title: "الشروط والأحكام",
  version: "1.0",
  updated: "2026-06-01",
  intro:
    "تحكم هذه الشروط استخدامك لمنصة HELCOO لإدارة الحضور والانصراف («الخدمة»)، سواء عبر الموقع أو تطبيقات الهاتف. باستخدامك للخدمة أو بإنشاء حساب فيها فإنك توافق على هذه الشروط بالكامل. إن كنت تقبلها نيابة عن شركة، فإنك تُقر بأنك مفوّض قانوناً بذلك.",
  sections: [
    {
      h: "1. تعريفات",
      p: ["«المشغّل» أو «نحن»: مالك منصة HELCOO. «العميل»: الشركة المشتركة في الخدمة. «المستخدم النهائي»: موظف العميل الذي يسجّل حضوره. «المحتوى»: أي بيانات يرفعها العميل أو مستخدموه."],
    },
    {
      h: "2. وصف الخدمة",
      p: ["توفّر الخدمة تسجيل حضور وانصراف بالتحقق من الوجه واختبار الحياة، والتحقق من الموقع الجغرافي (Geofencing)، وإدارة الورديات والإجازات والرواتب والتقارير. قد نطوّر الخدمة أو نعدّل ميزاتها مع إشعار مسبق بالتغييرات الجوهرية."],
    },
    {
      h: "3. الحساب والأهلية",
      p: ["يجب أن يكون عمر المستخدم 18 عاماً أو أكثر، أو 16 عاماً بموافقة صاحب العمل والوصي حيث يسمح القانون. أنت مسؤول عن سرية بيانات الدخول وعن كل نشاط يجري عبر حسابك، وعليك إبلاغنا فوراً عند الاشتباه بأي وصول غير مصرّح به."],
    },
    {
      h: "4. البيانات الحيوية (بصمة الوجه) — موافقة صريحة",
      p: [
        "يتطلب التحقق من الحضور معالجة صورة حية للوجه وإنشاء قالب رقمي (Face Template) للمطابقة. لا تُستخدم هذه البيانات لأي غرض آخر: لا للتسويق، ولا للإعلانات، ولا للتعرّف على الهوية خارج نطاق الحضور، ولا تُبَع أو تُشارك مع أي طرف ثالث لأغراض تجارية.",
        "يقرّ العميل بأنه المسؤول عن الحصول على موافقة صريحة ومكتوبة من كل موظف قبل تسجيل وجهه، بما يوافق القوانين المعمول بها. يمكن لأي مستخدم سحب موافقته بمراسلة صاحب العمل أو support@helcoo.uk، ويؤدي ذلك إلى حذف قالب الوجه وتوقّف التحقق بالوجه لحسابه.",
      ],
    },
    {
      h: "5. الموقع الجغرافي",
      p: ["تُستخدم إحداثيات الموقع لحظة تسجيل الحضور أو الانصراف فقط، للتأكد من وجود الموظف داخل نطاق الفرع. لا نتتبّع الموقع في الخلفية ولا خارج أوقات العمليات التي يبدأها المستخدم بنفسه."],
    },
    {
      h: "6. أدوار حماية البيانات",
      p: ["العميل هو «المتحكم بالبيانات» تجاه بيانات موظفيه، ونحن «المعالج» الذي يعالج البيانات وفق تعليمات العميل ولأغراض تشغيل الخدمة فقط."],
    },
    {
      id: "billing",
      h: "7. الاشتراك والفوترة (عقد أعمال)",
      p: [
        "هذا البند يخص الشركة العميلة حصراً بموجب عقد الأعمال، ولا ينطبق على مستخدمي التطبيق من الموظفين. تطبيقا iOS و Android مجانيان تماماً ولا يوجد فيهما أي شراء أو دفع من أي نوع.",
        "الاشتراك في الخدمة عقد أعمال بين HELCOO والشركة صاحبة العمل («العميل»)، يُبرَم ويُدار خارج متاجر التطبيقات. تبدأ الخدمة بفترة تجربة مجانية عند القبول، ثم تُحدَّد الرسوم وفق الخطة وعدد الموظفين المفعّلين، ويستمر الاشتراك للدورة التالية ما لم يُلغِه العميل قبل بدئها.",
        "الفوترة والاسترداد والإلغاء تخضع حصراً لعقد الأعمال المذكور ولا تخضع لسياسات فواتير أي متجر تطبيقات. الرسوم غير مستردة إلا في الحدود التي يقتضيها القانون أو ينص عليها العقد.",
        "تطبيقا iOS و Android مجانيان تماماً ولا يحتويان على أي عملية شراء داخل التطبيق ولا أسعار ولا أزرار اشتراك. الموظف (المستخدم النهائي) لا يدفع أي مبلغ لنا مطلقاً، ولا يُطلب منه أي بيانات دفع. عند إنهاء الاشتراك يُمنح العميل 30 يوماً لتصدير بياناته.",
      ],
    },
    {
      h: "8. الاستخدام المقبول",
      p: ["يُمنع الاحتيال في تسجيل الحضور (استخدام صور أو أقنعة أو تلاعب بالموقع)، أو الوصول غير المصرّح به، أو الهندسة العكسية، أو إعادة بيع الخدمة، أو تحميلها بأي محتوى مخالف للقانون أو منتهك لحقوق الغير."],
    },
    {
      h: "9. الملكية الفكرية",
      p: ["تبقى كل حقوق الملكية الفكرية في البرمجيات والتصميم والعلامة لنا. يبقى محتوى العميل مملوكاً له، ويمنحنا ترخيصاً محدوداً لمعالجته لتشغيل الخدمة فقط."],
    },
    {
      h: "10. إخلاء وتحديد المسؤولية",
      p: ["تُقدَّم الخدمة «كما هي» دون ضمان دقة مطلقة لأي عملية تحقق آلية. لا نتحمل المسؤولية عن الأضرار غير المباشرة أو فقدان الأرباح أو البيانات، وتقتصر مسؤوليتنا الإجمالية على المبالغ المدفوعة خلال الأشهر الاثني عشر السابقة للحدث."],
    },
    {
      h: "11. الإنهاء وحذف البيانات",
      p: ["يمكن لأي طرف إنهاء الاشتراك وفق هذه الشروط. عند الإنهاء يمكن للعميل تصدير بياناته خلال 30 يوماً، وتُحذف البيانات بعدها نهائياً، وتُحذف قوالب الوجه فوراً. لطلب حذف حسابك وبياناتك راسل support@helcoo.uk."],
    },
    {
      h: "12. تعديل الشروط",
      p: ["قد نُحدّث هذه الشروط، وسنشعر المستخدمين بالتغييرات الجوهرية قبل نفاذها. استمرارك في الاستخدام بعد النفاذ يعني قبولك النسخة المحدّثة."],
    },
    {
      h: "13. القانون الحاكم والتواصل",
      p: ["تخضع هذه الشروط لقوانين المملكة المتحدة مع مراعاة أي حقوق إلزامية للمستهلك في بلد إقامتك. للاستفسارات القانونية: support@helcoo.uk."],
    },
  ],
};
